import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { useId, useState } from 'react';
import { PaidUsersModal } from './paid-users-modal/PaidUsersModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IncludedUsersPreSeats = ({
  productLevel,
  includedWithParentProduct,
  skuCategoryName
}) => {
  const [paidUsersModalOpen, setPaidUsersModalOpen] = useState(false);
  const IncludedUsersTitleId = useId();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "body-125",
      id: IncludedUsersTitleId,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.includesPaidUsers",
        options: {
          count: includedWithParentProduct,
          includedPaidUsers: /*#__PURE__*/_jsx(Link, {
            onClick: () => setPaidUsersModalOpen(true),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedUsersPreSeats.paidUsers"
            })
          })
        }
      })
    }), paidUsersModalOpen && /*#__PURE__*/_jsx(PaidUsersModal, {
      productLevel: productLevel,
      onCloseClick: () => setPaidUsersModalOpen(false),
      skuCategoryName: skuCategoryName
    })]
  });
};